(function () {
    function initFlSliders() {
      document.querySelectorAll('[data-fl-slider]').forEach((root) => {
        const track = root.querySelector('[data-fl-slider-track]');
        const prev = root.querySelector('[data-fl-slider-prev]');
        const next = root.querySelector('[data-fl-slider-next]');
        if (!track || !prev || !next) return;
  
        const slideCount = track.children.length;
        if (slideCount === 0) return;
  
        function slideWidth() {
          return track.children[0] ? track.children[0].getBoundingClientRect().width : 0;
        }
  
        function updateDisabled() {
          const maxScroll = track.scrollWidth - track.clientWidth - 2;
          prev.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft >= maxScroll;
        }
  
        prev.addEventListener('click', () => {
          track.scrollBy({ left: -slideWidth() * 2, behavior: 'smooth' });
        });
        next.addEventListener('click', () => {
          track.scrollBy({ left: slideWidth() * 2, behavior: 'smooth' });
        });
        track.addEventListener('scroll', () => {
          window.requestAnimationFrame(updateDisabled);
        });
        window.addEventListener(
          'resize',
          () => {
            updateDisabled();
          },
          { passive: true }
        );
        updateDisabled();
      });
    }
  
    async function quickAdd(variantId, btn) {
      if (!variantId) return;
      btn.disabled = true;
      try {
        const fd = new FormData();
        fd.append('id', variantId);
        fd.append('quantity', '1');
        if (window.StarJewelryCart && typeof window.StarJewelryCart.add === 'function') {
          await window.StarJewelryCart.add(fd);
        } else {
          const res = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
          const data = await res.json().catch(() => ({}));
          if (!res.ok) throw new Error(data.description || data.message || 'Could not add');
        }
      } catch (e) {
        window.alert(e.message || 'Could not add');
      } finally {
        btn.disabled = false;
      }
    }
  
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-fl-quick-add]');
      if (!btn) return;
      e.preventDefault();
      const id = btn.getAttribute('data-variant-id');
      quickAdd(id, btn);
    });
  
    document.addEventListener('DOMContentLoaded', () => {
      initFlSliders();
    });
  })();
  